import React from 'react';
import { RiskManagment } from './riskManagment';

export function Template({
  template,
  conf
}) {
  switch (template) {
    case 'riskManagment':
      return <RiskManagment {...conf} />
    default:
      return null;

  }
}